import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromSignUpReducer from '../reducers/signup.reducer';
import * as fromAuthReducer from '../auth.reducer';

//#region AUTH ROOT STATE
export const getAuthState = createFeatureSelector<fromAuthReducer.State, fromAuthReducer.AuthState>(fromAuthReducer.authFeatureKey);
//#endregion

//#region Signup SUB STATE
export const getSignupState = createSelector(getAuthState, state => state[fromSignUpReducer.signupFeatureKey]);
//#endregion

//#region Signup
export const getSignupIsLoading = createSelector(getSignupState, fromSignUpReducer.getIsSignupLoading);
export const getSignupRequest = createSelector(getSignupState, fromSignUpReducer.getIsSignupRequest);
export const getSignupSuccess = createSelector(getSignupState, fromSignUpReducer.getIsSignupSuccess);
export const getSignupFailure = createSelector(getSignupState, fromSignUpReducer.getIsSignupFailure);
//#endregion
